<template>
    <div class="discount-check">
		<div v-if="viewMode != 'form'" class="bl_result_nomer" >
			<p v-if="cardInfo.PERCENT">Скидка по вашей карте</p>
			<div v-if="cardInfo.PERCENT" class="bl_result_nomer_procent">{{ cardInfo.PERCENT }}%</div>
			<div class="bl_result_nomer_text">
				<div v-if="cardInfo.PERCENT" >
					<div v-if="cardInfo.nextCondition && cardInfo.nextCondition.PERCENT" >
		                До скидки {{ cardInfo.nextCondition.PERCENT }}% Вам необходимо <br>накопить еще <b>{{ cardInfo.diff }} P</b>.<br>
		                {{ uploadDate ? 'По данным на ' + uploadDate : '' }}<br>
					</div>
					<div v-else >
		                У вас максимальная скидка!
						<br>
		                {{ uploadDate ? 'По данным на ' + uploadDate : '' }}<br>
					</div>
				</div>
				<div v-else >
		            Данных по карте не найдено<br>
				</div>
				<a @click="reset()" >Ввести новую карту</a>
		    </div>
		</div>
		<form v-show="viewMode == 'form'" @submit.prevent.stop="formSubmit($event)" method="POST" >
			<div :class="{ 'card_number_error' : incorrect, }" class="bl_enter_nomer_form clearfix" >
				<input
				v-model="cardNum"
				:class="userDevice == 'desktop' ? 'card_number_desktop' : 'card_number_mobile'"
				type="text"
				:size="userDevice == 'desktop' ? '17' : '17'"
				:maxlength="userDevice == 'desktop' ? '17' : '17'"
				name="card_number"
				>
				<input class="btn btn_red" name="card_submit" type="submit" value="Узнать" >
				<br><br>
			</div>
		</form>
	</div>
</template>

<script>
export default {
    name: 'DiscountCheck',
	props : {},
	computed : {
        userDevice : () => vxCommonStore.state.userDevice,
    },
	data : () => ({
		cardInfo : {},
		cardNum : '',
		incorrect : false,
		uploadDate : '',
		viewMode : 'form',
	}),
    mounted () {
        if (this.userDevice == 'desktop') {

        }
      $(document).on('keyup', '[name="card_number"]', (e) => {
        this.cardNum = $(e.currentTarget).val();
      });
      $('[name="card_number"]').inputmask('2  020999  999999');
    },
	watch : {
		cardInfo (val, oldVal) {
            if (val.PERCENT) {
                window.showHeaderMessage('Скидка по вашей карте ' + val.PERCENT + '%');
            }
			if (val.uploadTimestamp) {
				this.uploadDate =  moment.unix(val.uploadTimestamp).format('HH:mm от DD.MM.YYYY');
			}
		},
	},
	methods : {
		reset () {
			this.viewMode = 'form';
            this.cardInfo = {};
            this.cardNum = '';
		},
		formSubmit (e) {
			if (typeof(window.yaCounter15466654) != 'undefined') {
				window.yaCounter15466654.reachGoal('howmanypercent');
			}
            XPage.ajax({
                data : {
                    ajax_command : 'discount_check',
					cardNum : this.cardNum,
				},
                success : response => {
					if (response.error) {
        				if (response.message) {
        					window.showHeaderMessage(response.message, 'error');
        				}
					}
					if (response.incorrect) {
						this.incorrect = true;
						window.showHeaderMessage('Введите корректный номер', 'error');
					}
					if (response.cardInfo) {
						this.cardInfo = response.cardInfo;
					}
        			this.viewMode = 'info';
                }
            });
		},
	},
}
</script>
